import { useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../../_common/enum/forms/fomTemplateType.enum";
import { FormManageDrawer } from "../../form/form-manageDrawer";



export const ClientFormManageDrawer = (params: { isOpen?: boolean, onClose(): void }) => {
    const { clientId } = useParams<{ clientId: string }>();

    return (
        <>
            <FormManageDrawer formType={FormTemplateTypeEnum.Client} onClose={() => { params.onClose() }} id={clientId}></FormManageDrawer>
        </>
    );
};